export const DB_DATE_FORMAT = 'YYYY-MM-DD';
export const FORMAT_DATE_SHORT_OPTIONS = {year: 'numeric', month: 'short', day: '2-digit', timeZone: 'UTC'};
export const FORMAT_DATE_TINY_OPTIONS = {month: 'short', day: '2-digit', timeZone: 'UTC'};
